import { TimeFilterType } from '@profile/src/utils/types';
export const options = [{
  label: '1 hour',
  id: TimeFilterType.TIME_HOUR_1
}, {
  label: '24 hours',
  id: TimeFilterType.TIME_HOUR_24
}, {
  label: '7 days',
  id: TimeFilterType.TIME_DAY_7
}, {
  label: '14 days',
  id: TimeFilterType.TIME_DAY_14
}, {
  label: '30 days',
  id: TimeFilterType.TIME_DAY_30
}];